import { useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "../../store/auth.store";

export function ImpersonationBanner() {
  const impersonator = useAuthStore((s) => s.impersonator);
  const target = useAuthStore((s) => s.user);
  const stopImpersonating = useAuthStore((s) => s.stopImpersonating);
  const qc = useQueryClient();

  if (!impersonator || !target) return null;

  function handleStop() {
    stopImpersonating();
    // Cached queries belong to the impersonated user — clear them so the
    // restored admin session re-fetches fresh data.
    qc.clear();
  }

  return (
    <div className="impersonation-banner" role="status">
      <span>
        Impersonating <strong>{target.displayName ?? target.email}</strong> as{" "}
        <span className="muted">{impersonator.user.email}</span>
      </span>
      <button onClick={handleStop}>Stop impersonating</button>
    </div>
  );
}
